// Image helper methods

// Convert a file source to a File
export const srcToFile = (src, fileName, mimeType) => {
  return (fetch(src)
    .then((res) => {
      return res.arrayBuffer()
    }).then((buf) => {
      return new File([buf], fileName, {type:mimeType})
    })
  )
}


// WEBPACK FOOTER //
// ./src/helpers/image-helpers.js